import React, { useEffect } from "react";
import { useState, useRef, useCallback } from "react";
import { Bar, getElementAtEvent } from "react-chartjs-2";

import html2canvas from "html2canvas";
import { MDBCard } from "mdb-react-ui-kit";

const options = {
  responsive: true,
  maintainAspectRatio: false,

  indexAxis: "y",
  scales: {
    y: {
      ticks: {
        font: {
          size: 12,
        },
        z: 0,
      },
    },
    x: {
      min: 0,
      max: 1,
      type: "linear",
      beginAtZero: true,
      ticks: {
        display: false,
        autoSkip: false,
        stepSize: 0.25,
      },
    },
  },
  plugins: {
    legend: false,
  },
};

function scoreToGrade(score) {
  if (score >= 0 && score < 0.25) {
    return "beginner";
  } else if (score >= 0.25 && score < 0.5) {
    return "intermediate";
  } else if (score >= 0.5 && score < 0.75) {
    return "experienced";
  } else if (score >= 0.75 && score <= 1) {
    return "proficient";
  } else {
    return "";
  }
}
function scoreToColor(score) {
  if (score >= 0 && score < 0.25) {
    return "#C62917";
  } else if (score >= 0.25 && score < 0.5) {
    return "#EDA500";
  } else if (score >= 0.5 && score < 0.75) {
    return "#66B32E";
  } else if (score >= 0.75 && score <= 1) {
    return "#3F4F9F";
  } else {
    return "";
  }
}

function EmployeeComp({ ksaData, setImageUrl, imageUrl }) {
  const [, updateState] = useState();
  const [chartIndexFromClick, setChartIndexFromClick] = useState(-1);

  const [employeeKSA, setEmployeeKSA] = useState("");
  const [barHeight, setBarHeight] = useState(75);
  const [selectComp, setSelectComp] = useState("");

  const forceUpdate = useCallback(() => updateState({}), []);

  useEffect(() => {
    setEmployeeKSA(ksaData);
    if (ksaData !== null) {
      if (ksaData.length < 4) {
        setBarHeight(100);
      } else if (ksaData.length < 6) {
        setBarHeight(150);
      } else if (ksaData.length < 8) {
        setBarHeight(200);
      } else if (ksaData.length < 10) {
        setBarHeight(250);
      } else if (ksaData.length < 12) {
        setBarHeight(350);
      } else if (ksaData.length < 14) {
        setBarHeight(450);
      } else if (ksaData.length < 16) {
        setBarHeight(500);
      } else if (ksaData.length < 18) {
        setBarHeight(600);
      } else if (ksaData.length < 20) {
        setBarHeight(650);
      } else if (ksaData.length < 22) {
        setBarHeight(700);
      } else if (ksaData.length < 24) {
        setBarHeight(750);
      } else if (ksaData.length < 26) {
        setBarHeight(800);
      } else if (ksaData.length < 28) {
        setBarHeight(850);
      } else if (ksaData.length < 30) {
        setBarHeight(900);
      } else if (ksaData.length < 32) {
        setBarHeight(950);
      } else if (ksaData.length < 34) {
        setBarHeight(1000);
      } else if (ksaData.length < 36) {
        setBarHeight(1050);
      } else if (ksaData.length < 38) {
        setBarHeight(1100);
      } else if (ksaData.length < 40) {
        setBarHeight(1150);
      } else {
        setBarHeight(1000);
      }
    }
  }, [ksaData]);

  const newProfile = ksaData;

  var labels = [];
  var labelData = [];

  var labelDataChart = [{}];
  if (employeeKSA !== "" && employeeKSA !== null) {
    employeeKSA.sort((a, b) => {
      return b["score"] - a["score"];
    });

    for (let index = 0; index < employeeKSA.length; index++) {
      labelDataChart[index] = employeeKSA[index];
    }

    var newLabels = [];
    for (let index = 0; index < employeeKSA.length; index++) {
      newLabels[index] = labelDataChart[index]["title"]
        .toString()
        .match(/.{0,15}(?:\s|$)/g);
      //newLabels[index] = labelDataChart[index]["title"].toString().split(" ");
    }
    var chartData = {
      labels: newLabels,
      datasets: [
        {
          label: "Competency",
          barThickness: 50,
          minBarLength: 5,
          data: labelDataChart.map((col) => {
            if (col["score"] > 1) {
              col["score"] = col["score"] / 100;
              col["grade"] = scoreToGrade(col["grade"]);
              col["color"] = scoreToColor(col["score"]);
            }
            return col["score"];
          }),
          backgroundColor: labelDataChart.map((col) => {
            if (!col["color"]) {
              col["color"] = scoreToColor(col["score"]);
            }
            return col["color"];
          }),
        },
      ],
    };
  }

  const printElementAtEvent = (element) => {
    if (!element.length) return;

    const { datasetIndex, index } = element[0];
  };

  useEffect(() => {
    forceUpdate();
  }, [selectComp]);

  const chartRef = useRef();
  const onClickCCh = (event) => {
    setChartIndexFromClick(
      //usestate
      getElementAtEvent(chartRef.current, event)[0].index
    );
  };

  function CompDiv() {
    if (chartIndexFromClick !== -1) {
      return (
        <div className="chartCompDetails">
          <div>{labelDataChart[chartIndexFromClick]["title"]}</div>
          <p>{labelDataChart[chartIndexFromClick]["description"]}</p>
        </div>
      );
    } else {
      return (
        <div className="chartCompDetails">
          <div>
            Click on the bars to get more information about each competancy
          </div>
        </div>
      );
    }
  }
  return (
    <MDBCard className="empCompChartCard">
      <div className="empCompChart">
        {employeeKSA && (
          <div>
            <Bar
              id="actualChart"
              options={options}
              ref={chartRef}
              onClick={onClickCCh}
              data={chartData}
              height={barHeight}
              style={{
                maxHeight: `${barHeight * 3}px`,
                overflow: "auto",
              }}
            />
            <div className="empCompDetails">
              <CompDiv />
            </div>
          </div>
        )}
      </div>
    </MDBCard>
  );
}

export default EmployeeComp;
